import { environment } from "src/environments/environment";

export class Logger {
  static Log(msg, ...params) {
    if (!environment.production) {
      console.log(`%c ${msg}`, "color:#3f51b5", ...params);
    }
  }
}
